import {
  Alert,
  Autocomplete,
  Button,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { Card, Col, Container, Row, Table } from "react-bootstrap";
import React, { Fragment, useEffect, useState } from "react";
import { createNewTask, fetchTaskList, fetchEditTask } from "../actions/task";
import { useNavigate, useParams } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";

import Breadcrumb from "../components/Admin/Reusable/Breadcrumb";
import InputField from "../components/Admin/Reusable/InputField";
import SelectStatus from "../components/Admin/Reusable/Form/SelectStatus";
import SubmitButtonForm from "../components/Admin/Reusable/Form/SubmitButtonForm";
import { basicFormValidationHandler } from "../utils";
import { fetchCountryFormList } from "../actions/country";
import { isEmpty } from "lodash";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import FormSystemInformation from "../components/Admin/Reusable/FormSystemInformation";
import { fetchProductList } from "../actions/product";
import { fetchCustomFormExtendedList } from "../actions/customer";
import { fetchCompanyFormList } from "../actions/company";
import { fetchStoreFormExtendedList } from "../actions/store";
import { fetchEducationFormList } from "../actions/education";
import CloseIcon from "@mui/icons-material/Close";
import FormTitleMain from "../components/Admin/Reusable/FormTitleMain";
import { fetchProductCategoryAllFormList } from "../actions/productCategory";
import { fetchLevelList } from "../actions/level";

const TaskAdd = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const { t } = useTranslation();

  //breadcrumb
  const translateForm = "tasksForm";
  const translateModule = "tasks";
  const pageType = id ? "Edit" : "Add";
  const breadcrumbItems = [
    { label: t(`breadcrumb.${translateModule}`) },
    {
      label: t(`breadcrumb.${translateModule}${pageType}`),
      active: true,
    },
  ];

  const { levelList } = useSelector((state) => state.levelReducer);

  const [selectedCompany, setSelectedCompany] = useState(null);
  const [selectedStore, setSelectedStore] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedProductValue, setSelectedProductValue] = useState(null);
  const [selectedProductCategory, setSelectedProductCategory] = useState(null);
  const [selectedProductCategoryValue, setSelectedProductCategoryValue] =
    useState(null);
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [selectedEducation, setSelectedEducation] = useState(null);

  const [dataForm, setDataForm] = useState({
    companyList: [],
    storeList: [],
    accountList: [],
    educationList: [],
    productList: [],
    productCategoryList: [],
  });

  const handleAddToFormTableEducation = () => {
    if (selectedEducation) {
      const isEducationExists = dataForm?.educationList?.some(
        (education) => education.id === selectedEducation.id
      );

      if (!isEducationExists) {
        setDataForm((prevState) => ({
          ...prevState,
          educationList: [...prevState.educationList, selectedEducation],
        }));
        setSelectedEducation(null);
      } else {
        toast.error("Ova edukacija je već dodata!", { theme: "colored" });
      }
    }
  };

  const handleAddToFormTableProduct = () => {
    if (selectedProduct && selectedProductValue) {
      // Proveri da li kategorija već postoji u productList
      const isProductExists = dataForm.productList.some(
        (product) => product.id === selectedProduct.id
      );

      if (!isProductExists) {
        const newProduct = {
          id: selectedProduct.id,
          name: selectedProduct.name,
          categoryName: selectedProduct.categoryName,
          goal: selectedProductValue,
        };
        setDataForm((prevState) => ({
          ...prevState,
          productList: [...prevState.productList, newProduct],
        }));
        setSelectedProduct(null);
        setSelectedProductValue("");
      } else {
        toast.error("Ova kategorija je već dodata!", { theme: "colored" });
      }
    } else {
      toast.error("Morate popuniti sva polja!", { theme: "colored" });
    }
  };

  const handleAddToFormTableProductCategory = () => {
    if (selectedProductCategory && selectedProductCategoryValue) {
      // Proveri da li kategorija već postoji u productCategoryList
      const isProductExists = dataForm.productCategoryList.some(
        (product) => product.id === selectedProductCategory.id
      );

      if (!isProductExists) {
        const newProduct = {
          id: selectedProductCategory.id,
          name: selectedProductCategory.name,
          categoryName: "nemanja",
          goal: selectedProductCategoryValue,
        };
        setDataForm((prevState) => ({
          ...prevState,
          productCategoryList: [...prevState.productCategoryList, newProduct],
        }));
        setSelectedProductCategory(null);
        setSelectedProductCategoryValue("");
      } else {
        toast.error("Ova kategorija je već dodata!", { theme: "colored" });
      }
    } else {
      toast.error("Morate popuniti sva polja!", { theme: "colored" });
    }
  };
  const handleAddToFormTable = () => {
    if (selectedCompany) {
      // Proveri da li kompanija već postoji u companyList
      const isCompanyExists = dataForm.companyList.some(
        (company) => company.id === selectedCompany.id
      );

      if (!isCompanyExists) {
        setDataForm((prevState) => ({
          ...prevState,
          companyList: [...prevState.companyList, selectedCompany],
        }));
        setSelectedCompany(null);
      } else {
        toast.error("Ova kompanija je već dodata!", { theme: "colored" });
      }
    }
  };

  const handleAddToFormTableStore = () => {
    if (selectedStore) {
      // Proveri da li radnja već postoji u storeList
      const isStoreExists = dataForm.storeList.some(
        (store) => store.id === selectedStore.id
      );

      if (!isStoreExists) {
        setDataForm((prevState) => ({
          ...prevState,
          storeList: [...prevState.storeList, selectedStore],
        }));
        setSelectedStore(null);
      } else {
        toast.error("Ova radnja je već dodata!", { theme: "colored" });
      }
    }
  };

  const handleAddToFormTableAccount = () => {
    if (selectedAccount) {
      const isAccountExists = dataForm.accountList.some(
        (account) => account.id === selectedAccount.id
      );

      if (!isAccountExists) {
        setDataForm((prevState) => ({
          ...prevState,
          accountList: [...prevState.accountList, selectedAccount],
        }));
        setSelectedAccount(null);
      } else {
        toast.error("Ovaj korisnik je već dodata!", { theme: "colored" });
      }
    }
  };

  const handleRemoveFromFormTable = (id) => {
    setDataForm((prevState) => ({
      ...prevState,
      companyList: prevState.companyList.filter((company) => company.id !== id),
    }));
  };
  const handleRemoveFromFormTableProduct = (id) => {
    setDataForm((prevState) => ({
      ...prevState,
      productList: prevState.productList.filter((pro) => pro.id !== id),
    }));
  };
  const handleRemoveFromFormTableProductCategory = (id) => {
    setDataForm((prevState) => ({
      ...prevState,
      productCategoryList: prevState.productCategoryList.filter(
        (pro) => pro.id !== id
      ),
    }));
  };
  const handleRemoveFromFormTableStore = (id) => {
    setDataForm((prevState) => ({
      ...prevState,
      storeList: prevState.storeList.filter((store) => store.id !== id),
    }));
  };
  const handleRemoveFromFormTableAccount = (id) => {
    setDataForm((prevState) => ({
      ...prevState,
      accountList: prevState.accountList.filter((account) => account.id !== id),
    }));
  };
  const handleRemoveFromFormTableEducation = (id) => {
    setDataForm((prevState) => ({
      ...prevState,
      educationList: prevState.educationList.filter(
        (education) => education.id !== id
      ),
    }));
  };

  const initialState = {
    name: "",
    countryId: "",
    levelId: "",
    status: "ACTIVE",
    startDate: "",
    endDate: "",
    experience: "",
    sector: "DEVICE_FOR_HOUSE",
    experienceTask: "",
  };

  const [data, setData] = useState(initialState);
  const [errors, setErrors] = useState({});

  const { taskDetail } = useSelector((state) => state.taskReducer);

  const { countryFormList } = useSelector((state) => state.countryReducer);
  const { productCategoryAllFormList } = useSelector(
    (state) => state.productCategoryReducer
  );
  const { companyFormList } = useSelector((state) => state.companyReducer);
  const { customerExtendedFormList } = useSelector(
    (state) => state.customerReducer
  );
  const { productList } = useSelector((state) => state.productReducer);
  const { storeFormExtendedList } = useSelector((state) => state.storeReducer);
  const { educationFormList } = useSelector((state) => state.educationReducer);

  const handleInputChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const handleInputChangeProduct = (field, value) => {
    if (field === "productId") {
      setSelectedProduct(value);
    } else if (field === "goal") {
      setSelectedProductValue(value);
    }
  };

  const handleInputChangeProductCategory = (field, value) => {
    if (field === "categoryId") {
      setSelectedProductCategory(value);
    } else if (field === "goal") {
      setSelectedProductCategoryValue(value);
    }
  };

  useEffect(() => {
    if (countryFormList?.length == 1) {
      setData((prevData) => ({
        ...prevData,
        countryId: countryFormList[0].id,
      }));
      dispatch(fetchProductList());
      dispatch(fetchStoreFormExtendedList(countryFormList[0].id));
      dispatch(fetchCustomFormExtendedList(countryFormList[0].id));
      dispatch(fetchCompanyFormList(countryFormList[0].id));
      dispatch(fetchEducationFormList(countryFormList[0].id));
      dispatch(fetchProductCategoryAllFormList(countryFormList[0].id));
    }
  }, [countryFormList]);

  const handleInputChangeCountry = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
    dispatch(fetchProductList());
    dispatch(fetchStoreFormExtendedList(e.target.value));
    dispatch(fetchCustomFormExtendedList(e.target.value, data.sector));
    dispatch(fetchCompanyFormList(e.target.value));
    dispatch(fetchEducationFormList(e.target.value));
    dispatch(fetchProductCategoryAllFormList(e.target.value));

    //ocistiti sve liste ako su do sada unesene kada se promeni drzava
    setDataForm({
      companyList: [],
      storeList: [],
      accountList: [],
      educationList: [],
      productList: [],
      productCategoryList: [],
    });
  };

  const handleInputChangeSector = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
    dispatch(fetchProductList());
    dispatch(fetchStoreFormExtendedList(data.countryId));
    dispatch(fetchCustomFormExtendedList(data.countryId, e.target.value));
    dispatch(fetchCompanyFormList(data.countryId));
    dispatch(fetchEducationFormList(data.countryId));
    dispatch(fetchProductCategoryAllFormList(data.countryId));

    //ocistiti sve liste ako su do sada unesene kada se promeni drzava
    setDataForm({
      companyList: [],
      storeList: [],
      accountList: [],
      educationList: [],
      productList: [],
      productCategoryList: [],
    });
  };

  useEffect(() => {
    dispatch(fetchCountryFormList());
    dispatch(fetchLevelList());
  }, [dispatch]);

  useEffect(() => {
    if (!id) {
      // Ako `id` ne postoji, očisti stanje za novu kreaciju
      setData(initialState);
      setDataForm({
        companyList: [],
        storeList: [],
        accountList: [],
        educationList: [],
        productList: [],
        productCategoryList: [],
      });
    } else {
      // Ako `id` postoji, učitaj podatke za promociju
      dispatch(fetchTaskList(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    if (taskDetail) {
      const experienceItem = taskDetail?.itemDefinitions?.find(
        (item) => item.type === "EXPERIENCE"
      );

      setData({
        ...data,
        name: taskDetail.name || "",
        startDate: taskDetail.startDate || "",
        endDate: taskDetail.endDate || "",
        experience: taskDetail.experience || "",
        sector: taskDetail.sector || "DEVICE_FOR_HOUSE",
        status: taskDetail.status || "ACTIVE",
        countryId: taskDetail.countryId || "",
        levelId: taskDetail.levelId || "",
        companies: taskDetail.companies || [],
        stores: taskDetail.stores || [],
        accounts: taskDetail.targets || [],
        items: taskDetail.itemDefinitions || [],
        createdAt: taskDetail.createdAt || "",
        updatedAt: taskDetail.updatedAt || "",
        experienceTask: experienceItem?.goal ?? null,
      });

      if (taskDetail.countryId) {
        dispatch(fetchProductList());
        dispatch(fetchStoreFormExtendedList(taskDetail.countryId));
        dispatch(fetchCustomFormExtendedList(taskDetail.countryId));
        dispatch(fetchCompanyFormList(taskDetail.countryId));
        dispatch(fetchEducationFormList(taskDetail.countryId));
        dispatch(fetchProductCategoryAllFormList(taskDetail.countryId));
      }
    }
  }, [taskDetail, dispatch]);

  useEffect(() => {
    if (companyFormList.length > 0 && id) {
      //pronalazim selektovane kompanije
      const selectedCompanies = companyFormList.filter((company) =>
        data?.companies?.includes(company.id)
      );
      //setujem selektovane kompanije
      setDataForm((prevState) => ({
        ...prevState,
        companyList: selectedCompanies,
      }));
    }
  }, [companyFormList]);

  useEffect(() => {
    if (educationFormList.length > 0 && id) {
      // Filtriranje svih 'PRODUCT' tipova iz data.items
      const selectedProducts = educationFormList?.filter((education) =>
        data?.items?.some(
          (item) =>
            item.referenceId === education.id && item.type === "EDUCATION"
        )
      );

      // Kreiranje novih objekata sa potrebnim vrednostima
      const newProductList = selectedProducts.map((product) => {
        const item = data?.items?.find(
          (item) => item.referenceId === product.id && item.type === "EDUCATION"
        );

        // Kreiranje novog objekta sa vrednostima iz item-a
        const newProduct = {
          id: product.id,
          name: product.name,
          value: 1, // value = value iz data.items
        };

        return newProduct;
      });

      // Ažuriranje productList sa novim proizvodima bez dupliranja
      setDataForm((prevState) => ({
        ...prevState,
        educationList: [
          ...prevState.educationList,
          ...newProductList.filter(
            (newProduct) =>
              !prevState.educationList.some(
                (product) => product.id === newProduct.id
              )
          ),
        ],
      }));
    }
  }, [educationFormList, data]);

  useEffect(() => {
    if (productCategoryAllFormList.length > 0 && id) {
      // Filtriranje svih 'PRODUCT' tipova iz data.items

      const allCategories = flattenCategories(productCategoryAllFormList);

      const selectedProducts = allCategories.filter((product) =>
        data?.items?.some(
          (item) => item.referenceId === product.id && item.type === "CATEGORY"
        )
      );

      // Kreiranje novih objekata sa potrebnim vrednostima
      const newProductList = selectedProducts.map((product) => {
        const item = data.items.find(
          (item) => item.referenceId === product.id && item.type === "CATEGORY"
        );

        // Kreiranje novog objekta sa vrednostima iz item-a
        const newProduct = {
          id: product.id,
          name: product.name,
          categoryName: "",
          goal: item?.goal,
        };

        return newProduct;
      });

      // Ažuriranje productList sa novim proizvodima bez dupliranja
      setDataForm((prevState) => ({
        ...prevState,
        productCategoryList: [
          ...prevState.productCategoryList,
          ...newProductList.filter(
            (newProduct) =>
              !prevState.productCategoryList.some(
                (product) => product.id === newProduct.id
              )
          ),
        ],
      }));
    }
  }, [productCategoryAllFormList, data]);

  useEffect(() => {
    if (productList.length > 0 && id) {
      // Filtriranje svih 'PRODUCT' tipova iz data.items
      const selectedProducts = productList.filter((product) =>
        data?.items?.some(
          (item) => item.referenceId === product.id && item.type === "PRODUCT"
        )
      );

      // Kreiranje novih objekata sa potrebnim vrednostima
      const newProductList = selectedProducts.map((product) => {
        const item = data.items.find(
          (item) => item.referenceId === product.id && item.type === "PRODUCT"
        );

        // Kreiranje novog objekta sa vrednostima iz item-a
        const newProduct = {
          id: product.id,
          name: product.name,
          categoryName: product.categoryName,
          goal: item?.goal,
        };

        return newProduct;
      });

      // Ažuriranje productList sa novim proizvodima bez dupliranja
      setDataForm((prevState) => ({
        ...prevState,
        productList: [
          ...prevState.productList,
          ...newProductList.filter(
            (newProduct) =>
              !prevState.productList.some(
                (product) => product.id === newProduct.id
              )
          ),
        ],
      }));
    }
  }, [productList, data]);

  useEffect(() => {
    if (storeFormExtendedList.length > 0 && id) {
      //pronalazim selektovane kompanije
      const selectedStores = storeFormExtendedList.filter((store) =>
        data?.stores?.includes(store.id)
      );
      //setujem selektovane kompanije
      setDataForm((prevState) => ({
        ...prevState,
        storeList: selectedStores,
      }));
    }
  }, [storeFormExtendedList]);

  useEffect(() => {
    if (customerExtendedFormList.length > 0 && id) {
      //pronalazim selektovane kompanije
      const selectedAccount = customerExtendedFormList.filter((product) =>
        data?.accounts?.some((item) => item.id === product.id)
      );
      //setujem selektovane kompanije
      setDataForm((prevState) => ({
        ...prevState,
        accountList: selectedAccount,
      }));
    }
  }, [customerExtendedFormList]);

  const clientValidationHandler = () => {
    const { name, countryId, startDate, endDate, experience, levelId } = data;

    let errorsObject = {};

    errorsObject = basicFormValidationHandler(
      {
        name,
        startDate,
        endDate,
        countryId,
        levelId,
        experience,
      },
      t
    );

    setErrors(errorsObject);

    if (!isEmpty(errorsObject))
      toast.error("Morate popuniti sva obavezna polja", { theme: "colored" });
    return !isEmpty(errorsObject);
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (clientValidationHandler()) {
      return;
    }

    if (
      dataForm.educationList.length === 0 &&
      dataForm.productList.length === 0 &&
      dataForm.productCategoryList.length === 0
    ) {
      toast.error("Morate odabrati edukaciju, kategoriju ili proizvod", {
        theme: "colored",
      });
      return;
    }

    const items = {
      stores: dataForm.storeList.map((store) => store.id),
      companies: dataForm.companyList.map((company) => company.id),
      accounts: dataForm.accountList.map((account) => account.id),
      items: [
        ...dataForm.productList.map((product) => ({
          referenceId: product.id,
          goal: product.goal,
          type: "PRODUCT",
        })),
        ...dataForm.educationList.map((education) => ({
          referenceId: education.id,
          goal: 1,
          type: "EDUCATION",
        })),
        ...dataForm.productCategoryList.map((product) => ({
          referenceId: product.id,
          goal: product.goal,
          type: "CATEGORY",
        })),
        ...(data?.experienceTask
          ? [
              {
                referenceId: null,
                goal: data.experienceTask,
                type: "EXPERIENCE",
              },
            ]
          : []),
      ],
      name: data.name,
      startDate: data.startDate,
      endDate: data.endDate,
      experience: data.experience,
      sector: data.sector,
      status: data.status,
      countryId: data.countryId,
      levelId: data.levelId,
    };

    if (id) {
      items.id = id;
      dispatch(fetchEditTask(items, navigate));
    } else {
      dispatch(createNewTask(items, navigate));
    }
  };

  const flattenCategories = (categories) => {
    const result = [];

    const traverse = (items) => {
      items.forEach((item) => {
        result.push({
          id: item.id,
          name: item.name,
        });
        if (item.children && item.children.length > 0) {
          traverse(item.children);
        }
      });
    };

    traverse(categories);
    return result;
  };

  // Primer upotrebe:
  const allCategories = flattenCategories(productCategoryAllFormList);

  return (
    <Fragment>
      <Breadcrumb
        breadcrumbItems={breadcrumbItems}
        type={translateModule}
        id={id}
        pageType={pageType}
        extraTitle={taskDetail && taskDetail.name}
      />
      <Container>
        <Row>
          <Col lg={12}>
            <form onSubmit={handleSubmit} noValidate>
              <Row>
                <Col lg={12}>
                  <div className="text-end mb-2">
                    {!id && <SubmitButtonForm id={id} />}
                  </div>
                </Col>
              </Row>

              <Row>
                <Col lg={9}>
                  <Row>
                    <Col lg={12}>
                      <Card>
                        <Card.Header>
                          <FormTitleMain />
                        </Card.Header>
                        <Card.Body>
                          <div className="task-holder-admin-left-side-text">
                            <Row>
                              <Col lg={5} md={12} xs={12} className="mb-4">
                                <InputField
                                  label={t("taskAdd.name")}
                                  name="name"
                                  value={data?.name}
                                  onChange={handleInputChange}
                                  error={errors}
                                  errorsHandler={setErrors}
                                  fullWidth
                                  size="small"
                                  required
                                  disabled={id}
                                />
                              </Col>
                              <Col lg={3} md={12} xs={12} className="mb-3">
                                <FormControl
                                  fullWidth
                                  required
                                  size="small"
                                  error={errors?.levelId ? true : false}
                                  disabled={id || countryFormList?.length === 1}
                                >
                                  <InputLabel id="demo-simple-select-label">
                                    {t("taskAdd.country")}
                                  </InputLabel>
                                  <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={data?.countryId}
                                    label={t("taskAdd.country")}
                                    name="countryId"
                                    onChange={handleInputChangeCountry}
                                    size="small"
                                  >
                                    {countryFormList?.map((item, key) => (
                                      <MenuItem value={item.id} key={key}>
                                        {item.name}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                  {errors?.countryId && (
                                    <FormHelperText>
                                      {t("taskAdd.requiredField")}
                                    </FormHelperText>
                                  )}
                                </FormControl>
                              </Col>
                              <Col lg={4} md={12} xs={12} className="mb-4">
                                <FormControl
                                  fullWidth
                                  required
                                  size="small"
                                  error={errors?.sector ? true : false}
                                  disabled={id || !data.countryId}
                                >
                                  <InputLabel id="demo-simple-select-label">
                                    {t("global.sectorName")}
                                  </InputLabel>
                                  <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={data?.sector}
                                    label={t("global.sectorName")}
                                    name="sector"
                                    onChange={handleInputChangeSector}
                                    size="small"
                                  >
                                    <MenuItem value={"DEVICE_FOR_HOUSE"}>
                                      {t("global.DEVICE_FOR_HOUSE")}
                                    </MenuItem>
                                    <MenuItem value={"TV_AUDIO"}>
                                      {t("global.TV_AUDIO")}
                                    </MenuItem>
                                    <MenuItem
                                      value={"DEVICE_FOR_HOUSE_AND_TV_AUDIO"}
                                    >
                                      {t(
                                        "global.DEVICE_FOR_HOUSE_AND_TV_AUDIO"
                                      )}
                                    </MenuItem>
                                  </Select>
                                </FormControl>
                              </Col>
                              <Col lg={4} md={12} xs={12} className="mb-4">
                                <InputField
                                  label={t("taskAdd.experience")}
                                  name="experience"
                                  value={data?.experience}
                                  onChange={handleInputChange}
                                  error={errors}
                                  errorsHandler={setErrors}
                                  fullWidth
                                  size="small"
                                  required
                                  disabled={id}
                                />
                              </Col>
                              <Col lg={4} md={12} xs={12} className="mb-4">
                                <InputField
                                  label={t("taskAdd.experienceTask")}
                                  name="experienceTask"
                                  value={data?.experienceTask}
                                  onChange={handleInputChange}
                                  error={errors}
                                  errorsHandler={setErrors}
                                  fullWidth
                                  size="small"
                                  disabled={id}
                                />
                              </Col>
                              <Col lg={4} md={12} xs={12} className="mb-3">
                                <FormControl
                                  fullWidth
                                  required
                                  size="small"
                                  error={errors?.levelId ? true : false}
                                  disabled={id}
                                >
                                  <InputLabel id="demo-simple-select-label">
                                    {t("awardForm.level")}
                                  </InputLabel>
                                  <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={data?.levelId}
                                    label={t("awardForm.level")}
                                    name="levelId"
                                    onChange={handleInputChange}
                                    size="small"
                                    required
                                  >
                                    {levelList?.map((item, key) => (
                                      <MenuItem value={item.id} key={key}>
                                        {item.name}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                  {errors?.levelId && (
                                    <FormHelperText>
                                      {t("awardForm.requiredField")}
                                    </FormHelperText>
                                  )}
                                </FormControl>
                              </Col>
                              <Col lg={3} md={12} xs={12} className="mb-4">
                                <InputField
                                  type="date"
                                  label={t("taskAdd.startDate")}
                                  name="startDate"
                                  value={data?.startDate}
                                  onChange={handleInputChange}
                                  error={errors}
                                  errorsHandler={setErrors}
                                  fullWidth
                                  size="small"
                                  required
                                  disabled={id}
                                  inputLabelProps={{ shrink: true }}
                                  inputProps={{
                                    max: data?.endDate || undefined,
                                  }}
                                />
                              </Col>
                              <Col lg={3} md={12} xs={12} className="mb-4">
                                <InputField
                                  type="date"
                                  label={t("taskAdd.endDate")}
                                  name="endDate"
                                  value={data?.endDate}
                                  onChange={handleInputChange}
                                  error={errors}
                                  errorsHandler={setErrors}
                                  fullWidth
                                  size="small"
                                  required
                                  disabled={id}
                                  inputLabelProps={{ shrink: true }}
                                  inputProps={{
                                    min: data?.startDate || undefined,
                                  }}
                                />
                              </Col>
                            </Row>
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                    {data.countryId && (
                      <Fragment>
                        {!id && (
                          <Fragment>
                            <Col lg={6}>
                              <Card>
                                <Card.Header>
                                  {t("taskAdd.selectCompany")}
                                </Card.Header>
                                <Card.Body>
                                  <Row>
                                    <Col lg={12}>
                                      {!id && (
                                        <div className="form-input-add-holder d-flex gap-2 justify-content-between align-items-center mb-3">
                                          <Autocomplete
                                            options={companyFormList}
                                            getOptionLabel={(option) =>
                                              option.name
                                            }
                                            fullWidth
                                            value={selectedCompany}
                                            onChange={(e, newValue) => {
                                              setSelectedCompany(newValue);
                                            }}
                                            renderInput={(params) => (
                                              <TextField
                                                {...params}
                                                label={t("taskAdd.company")}
                                                size="small"
                                              />
                                            )}
                                          />
                                          <Button
                                            variant="contained"
                                            onClick={handleAddToFormTable}
                                            startIcon={<AddIcon />}
                                          >
                                            {t("taskAdd.add")}
                                          </Button>
                                        </div>
                                      )}
                                      {dataForm?.companyList?.length > 0 ? (
                                        <Table
                                          bordered
                                          hover
                                          size="sm"
                                          responsive="sm"
                                          striped
                                          className="mb-0"
                                        >
                                          <thead>
                                            <tr>
                                              <th className="text-center text-bold">
                                                {t("taskAdd.company")}
                                              </th>
                                              {!id && (
                                                <th
                                                  className="text-center"
                                                  width="1%"
                                                ></th>
                                              )}
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {dataForm?.companyList?.map(
                                              (item, key) => (
                                                <tr key={key}>
                                                  <td>{item.name}</td>
                                                  {!id && (
                                                    <td className="text-center">
                                                      <CloseIcon
                                                        sx={{
                                                          cursor: "pointer",
                                                        }}
                                                        onClick={() =>
                                                          handleRemoveFromFormTable(
                                                            item.id
                                                          )
                                                        }
                                                      />
                                                    </td>
                                                  )}
                                                </tr>
                                              )
                                            )}
                                          </tbody>
                                        </Table>
                                      ) : (
                                        <Alert severity="info">
                                          {t("taskAdd.noSelectedCompany")}
                                        </Alert>
                                      )}
                                    </Col>
                                  </Row>
                                </Card.Body>
                              </Card>
                            </Col>

                            <Col lg={6}>
                              <Card>
                                <Card.Header>
                                  {t("taskAdd.selectStore")}
                                </Card.Header>
                                <Card.Body>
                                  <Row>
                                    <Col lg={12}>
                                      {!id && (
                                        <div className="form-input-add-holder d-flex gap-2 justify-content-between align-items-center mb-3">
                                          <Autocomplete
                                            options={storeFormExtendedList}
                                            getOptionLabel={(option) =>
                                              option.name
                                            }
                                            fullWidth
                                            value={selectedStore}
                                            onChange={(e, newValue) => {
                                              setSelectedStore(newValue);
                                            }}
                                            renderInput={(params) => (
                                              <TextField
                                                {...params}
                                                label={t("taskAdd.store")}
                                                size="small"
                                              />
                                            )}
                                          />
                                          <Button
                                            variant="contained"
                                            onClick={handleAddToFormTableStore}
                                            startIcon={<AddIcon />}
                                          >
                                            {t("taskAdd.add")}
                                          </Button>
                                        </div>
                                      )}
                                      {dataForm?.storeList?.length > 0 ? (
                                        <Table
                                          bordered
                                          hover
                                          size="sm"
                                          responsive="sm"
                                          striped
                                          className="mb-0"
                                        >
                                          <thead>
                                            <tr>
                                              <th className="text-center text-bold">
                                                {t("taskAdd.store")}
                                              </th>
                                              <th className="text-center text-bold">
                                                {t("taskAdd.company")}
                                              </th>
                                              {!id && (
                                                <th
                                                  className="text-center"
                                                  width="1%"
                                                ></th>
                                              )}
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {dataForm?.storeList?.map(
                                              (item, key) => (
                                                <tr key={key}>
                                                  <td>{item.name}</td>
                                                  <td>{item.companyName}</td>
                                                  {!id && (
                                                    <td className="text-center">
                                                      <CloseIcon
                                                        sx={{
                                                          cursor: "pointer",
                                                        }}
                                                        onClick={() =>
                                                          handleRemoveFromFormTableStore(
                                                            item.id
                                                          )
                                                        }
                                                      />
                                                    </td>
                                                  )}
                                                </tr>
                                              )
                                            )}
                                          </tbody>
                                        </Table>
                                      ) : (
                                        <Alert severity="info">
                                          {t("taskAdd.noSelectedStore")}
                                        </Alert>
                                      )}
                                    </Col>
                                  </Row>
                                </Card.Body>
                              </Card>
                            </Col>
                          </Fragment>
                        )}
                        <Fragment>
                          <Col lg={12}>
                            <Card>
                              <Card.Header>
                                {t("taskAdd.selectUser")}
                              </Card.Header>
                              <Card.Body>
                                <Row>
                                  <Col lg={12}>
                                    {!id && (
                                      <div className="form-input-add-holder d-flex gap-2 justify-content-between align-items-center mb-3">
                                        <Autocomplete
                                          options={customerExtendedFormList}
                                          getOptionLabel={(option) =>
                                            `${option.name} ${
                                              option.lastName
                                            } (${option.companyName} / ${
                                              option.storeName
                                            } / ${t(
                                              `global.${option.sector}`
                                            )})`
                                          }
                                          fullWidth
                                          value={selectedAccount}
                                          onChange={(e, newValue) => {
                                            setSelectedAccount(newValue);
                                          }}
                                          renderInput={(params) => (
                                            <TextField
                                              {...params}
                                              label={t("taskAdd.user")}
                                              size="small"
                                            />
                                          )}
                                        />
                                        <Button
                                          variant="contained"
                                          onClick={handleAddToFormTableAccount}
                                          startIcon={<AddIcon />}
                                        >
                                          {t("taskAdd.add")}
                                        </Button>
                                      </div>
                                    )}
                                    {dataForm?.accountList?.length > 0 ? (
                                      <Table
                                        bordered
                                        hover
                                        size="sm"
                                        responsive="sm"
                                        striped
                                        className="mb-0"
                                      >
                                        <thead>
                                          <tr>
                                            <th className="text-center text-bold">
                                              {t("taskAdd.user")}
                                            </th>
                                            <th className="text-center text-bold">
                                              {t("taskAdd.company")}
                                            </th>
                                            <th className="text-center text-bold">
                                              {t("taskAdd.store")}
                                            </th>
                                            <th className="text-center text-bold">
                                              {t("taskAdd.sectorName")}
                                            </th>
                                            {!id && (
                                              <th
                                                className="text-center"
                                                width="1%"
                                              ></th>
                                            )}
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {dataForm?.accountList?.map(
                                            (item, key) => (
                                              <tr key={key}>
                                                <td>
                                                  {item.name} {item.lastName}
                                                </td>
                                                <td>{item.companyName}</td>
                                                <td>{item.storeName}</td>
                                                <td>
                                                  {t(`global.${item.sector}`)}
                                                </td>
                                                {!id && (
                                                  <td className="text-center">
                                                    <CloseIcon
                                                      sx={{ cursor: "pointer" }}
                                                      onClick={() =>
                                                        handleRemoveFromFormTableAccount(
                                                          item.id
                                                        )
                                                      }
                                                    />
                                                  </td>
                                                )}
                                              </tr>
                                            )
                                          )}
                                        </tbody>
                                      </Table>
                                    ) : (
                                      <Alert severity="info">
                                        {t("taskAdd.noSelectedUser")}
                                      </Alert>
                                    )}
                                  </Col>
                                </Row>
                              </Card.Body>
                            </Card>
                          </Col>

                          <Col lg={12}>
                            <Card>
                              <Card.Header>
                                {t("taskAdd.selectEducation")}
                              </Card.Header>
                              <Card.Body>
                                <Row>
                                  <Col lg={12}>
                                    {!id && (
                                      <div className="form-input-add-holder d-flex gap-2 justify-content-between align-items-center mb-3">
                                        <Autocomplete
                                          options={educationFormList}
                                          getOptionLabel={(option) =>
                                            `${option.name}`
                                          }
                                          fullWidth
                                          value={selectedEducation}
                                          onChange={(e, newValue) => {
                                            setSelectedEducation(newValue);
                                          }}
                                          renderInput={(params) => (
                                            <TextField
                                              {...params}
                                              label={t("taskAdd.education")}
                                              size="small"
                                            />
                                          )}
                                        />
                                        <Button
                                          variant="contained"
                                          onClick={
                                            handleAddToFormTableEducation
                                          }
                                          startIcon={<AddIcon />}
                                        >
                                          {t("taskAdd.add")}
                                        </Button>
                                      </div>
                                    )}
                                    {dataForm?.educationList?.length > 0 ? (
                                      <Table
                                        bordered
                                        hover
                                        size="sm"
                                        responsive="sm"
                                        striped
                                        className="mb-0"
                                      >
                                        <thead>
                                          <tr>
                                            <th className="text-center text-bold">
                                              {t("taskAdd.education")}
                                            </th>
                                            {!id && (
                                              <th
                                                className="text-center"
                                                width="1%"
                                              ></th>
                                            )}
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {dataForm?.educationList?.map(
                                            (item, key) => (
                                              <tr key={key}>
                                                <td>{item.name}</td>
                                                {!id && (
                                                  <td className="text-center">
                                                    <CloseIcon
                                                      sx={{ cursor: "pointer" }}
                                                      onClick={() =>
                                                        handleRemoveFromFormTableEducation(
                                                          item.id
                                                        )
                                                      }
                                                    />
                                                  </td>
                                                )}
                                              </tr>
                                            )
                                          )}
                                        </tbody>
                                      </Table>
                                    ) : (
                                      <Alert severity="info">
                                        {t("taskAdd.noSelectedEducation")}
                                      </Alert>
                                    )}
                                  </Col>
                                </Row>
                              </Card.Body>
                            </Card>
                          </Col>
                        </Fragment>

                        <Fragment>
                          <Col lg={12}>
                            <Card>
                              <Card.Header>
                                Odaberite kategoriju proizvoda
                              </Card.Header>
                              <Card.Body>
                                {!id && (
                                  <div className="form-input-add-holder">
                                    <Row>
                                      <Col
                                        lg={6}
                                        md={12}
                                        xs={12}
                                        className="mb-4"
                                      >
                                        <Autocomplete
                                          options={allCategories}
                                          getOptionLabel={(option) =>
                                            option.name
                                          }
                                          value={selectedProductCategory}
                                          onChange={(e, newValue) => {
                                            handleInputChangeProductCategory(
                                              "categoryId",
                                              newValue
                                            );
                                          }}
                                          renderInput={(params) => (
                                            <TextField
                                              {...params}
                                              label={"Kategorija"}
                                              size="small"
                                            />
                                          )}
                                        />
                                      </Col>
                                      <Col
                                        lg={4}
                                        md={12}
                                        xs={12}
                                        className="mb-4"
                                      >
                                        <InputField
                                          label={t("taskAdd.quantity")}
                                          name="value"
                                          value={selectedProductCategoryValue}
                                          onChange={(e) =>
                                            handleInputChangeProductCategory(
                                              "goal",
                                              e.target.value
                                            )
                                          }
                                          fullWidth
                                          size="small"
                                        />
                                      </Col>
                                      <Col
                                        lg={2}
                                        md={12}
                                        xs={12}
                                        className="mb-4"
                                      >
                                        <Button
                                          variant="contained"
                                          onClick={
                                            handleAddToFormTableProductCategory
                                          }
                                          startIcon={<AddIcon />}
                                        >
                                          {t("taskAdd.add")}
                                        </Button>
                                      </Col>
                                    </Row>
                                  </div>
                                )}
                                {dataForm?.productCategoryList?.length > 0 ? (
                                  <Table
                                    bordered
                                    hover
                                    size="sm"
                                    responsive="sm"
                                    striped
                                    className="mb-0"
                                  >
                                    <thead>
                                      <tr>
                                        <th className="text-center text-bold">
                                          {t("taskAdd.category")}
                                        </th>
                                        <th
                                          className="text-center text-bold"
                                          width="10%"
                                        >
                                          {t("taskAdd.quantity")}
                                        </th>
                                        {!id && (
                                          <th
                                            className="text-center"
                                            width="1%"
                                          ></th>
                                        )}
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {dataForm?.productCategoryList?.map(
                                        (item, key) => (
                                          <tr key={key}>
                                            <td>{item.name}</td>
                                            <td>{item.goal}</td>
                                            {!id && (
                                              <td className="text-center">
                                                <CloseIcon
                                                  sx={{ cursor: "pointer" }}
                                                  onClick={() =>
                                                    handleRemoveFromFormTableProductCategory(
                                                      item.id
                                                    )
                                                  }
                                                />
                                              </td>
                                            )}
                                          </tr>
                                        )
                                      )}
                                    </tbody>
                                  </Table>
                                ) : (
                                  <Alert severity="info">
                                    {t("taskAdd.noSelectedProduct")}
                                  </Alert>
                                )}
                              </Card.Body>
                            </Card>
                          </Col>
                        </Fragment>

                        <Fragment>
                          <Col lg={12}>
                            <Card>
                              <Card.Header>
                                <div className="d-flex align-items-center justify-content-between">
                                  <div className="card-title-item">
                                    {t("taskAdd.selectProduct")}
                                  </div>
                                </div>
                              </Card.Header>
                              <Card.Body>
                                {!id && (
                                  <div className="form-input-add-holder">
                                    <Row>
                                      <Col
                                        lg={6}
                                        md={12}
                                        xs={12}
                                        className="mb-4"
                                      >
                                        <Autocomplete
                                          options={productList}
                                          getOptionLabel={(option) =>
                                            option.name
                                          }
                                          value={selectedProduct}
                                          onChange={(e, newValue) => {
                                            handleInputChangeProduct(
                                              "productId",
                                              newValue
                                            );
                                          }}
                                          renderInput={(params) => (
                                            <TextField
                                              {...params}
                                              label={t("taskAdd.product")}
                                              size="small"
                                            />
                                          )}
                                        />
                                      </Col>
                                      <Col
                                        lg={4}
                                        md={12}
                                        xs={12}
                                        className="mb-4"
                                      >
                                        <InputField
                                          label={t("taskAdd.quantity")}
                                          name="value"
                                          value={selectedProductValue}
                                          onChange={(e) =>
                                            handleInputChangeProduct(
                                              "goal",
                                              e.target.value
                                            )
                                          }
                                          fullWidth
                                          size="small"
                                        />
                                      </Col>
                                      <Col
                                        lg={2}
                                        md={12}
                                        xs={12}
                                        className="mb-4"
                                      >
                                        <Button
                                          variant="contained"
                                          onClick={handleAddToFormTableProduct}
                                          startIcon={<AddIcon />}
                                        >
                                          {t("taskAdd.add")}
                                        </Button>
                                      </Col>
                                    </Row>
                                  </div>
                                )}
                                {dataForm?.productList?.length > 0 ? (
                                  <Table
                                    bordered
                                    hover
                                    size="sm"
                                    responsive="sm"
                                    striped
                                    className="mb-0"
                                  >
                                    <thead>
                                      <tr>
                                        <th className="text-center text-bold">
                                          {t("taskAdd.category")}
                                        </th>
                                        <th className="text-center text-bold">
                                          {t("taskAdd.categoryBelongs")}
                                        </th>
                                        <th
                                          className="text-center text-bold"
                                          width="10%"
                                        >
                                          {t("taskAdd.quantity")}
                                        </th>
                                        {!id && (
                                          <th
                                            className="text-center"
                                            width="1%"
                                          ></th>
                                        )}
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {dataForm?.productList?.map(
                                        (item, key) => (
                                          <tr key={key}>
                                            <td>{item.name}</td>
                                            <td>{item.categoryName}</td>
                                            <td>{item.goal}</td>
                                            {!id && (
                                              <td className="text-center">
                                                <CloseIcon
                                                  sx={{ cursor: "pointer" }}
                                                  onClick={() =>
                                                    handleRemoveFromFormTableProduct(
                                                      item.id
                                                    )
                                                  }
                                                />
                                              </td>
                                            )}
                                          </tr>
                                        )
                                      )}
                                    </tbody>
                                  </Table>
                                ) : (
                                  <Alert severity="info">
                                    {t("taskAdd.noSelectedProduct")}
                                  </Alert>
                                )}
                              </Card.Body>
                            </Card>
                          </Col>
                        </Fragment>
                      </Fragment>
                    )}
                  </Row>
                </Col>
                <Col lg={3}>
                  <Row>
                    <Col lg={12}>
                      <SelectStatus
                        data={data}
                        handleInputChange={handleInputChange}
                      />
                    </Col>

                    {id && (
                      <Col lg={12}>
                        <FormSystemInformation data={data} />
                      </Col>
                    )}
                  </Row>
                </Col>
              </Row>
            </form>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default TaskAdd;
